// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const MaterialTemplateIdToJson = [
  "/static/materials/templates/Carpet.default.json",
  "/static/materials/templates/Color_PlanFloor.default.json",
  "/static/materials/templates/Color.default.json",
  "/static/materials/templates/Floor_Concrete.default.json",
  "/static/materials/templates/Floor_Tile_Carrara.default.json",
  "/static/materials/templates/Floor_Tile.default.json",
  "/static/materials/templates/Floor_Wood.default.json",
  "/static/materials/templates/Garage.default.json",
  "/static/materials/templates/Glass_Base.default.json",
  "/static/materials/templates/Grass_Lawn_01.default.json",
  "/static/materials/templates/Grass_Lawn_01.default.json",
  "/static/materials/templates/Gutter.default.json",
  "/static/materials/templates/Metal_Powder.default.json",
  "/static/materials/templates/Metal_Screen.default.json",
  "/static/materials/templates/Paint_Egg.default.json",
  "/static/materials/templates/Paint_Flat.default.json",
  "/static/materials/templates/Paint_Gloss.default.json",
  "/static/materials/templates/Paint_Satin.default.json",
  "/static/materials/templates/Paint_SemiGloss.default.json",
  "/static/materials/templates/Roof_Asphalt.default.json",
  "/static/materials/templates/Roof_Asphalt3Tab.default.json",
  "/static/materials/templates/Roof_AsphaltShake.default.json",
  "/static/materials/templates/Roof_Rubber.default.json",
  "/static/materials/templates/Roof_StandingSeam12.default.json",
  "/static/materials/templates/Roof_StandingSeam12.default.json",
  "/static/materials/templates/Roof_StandingSeam16.default.json",
  "/static/materials/templates/Roof_StandingSeamIR.default.json",
  "/static/materials/templates/Roof_StandingSeamPBU_Galvanized.default.json",
  "/static/materials/templates/RoofTrim_AsphaltShingle.default.json",
  "/static/materials/templates/RoofTrim_StandingSeam.default.json",
  "/static/materials/templates/RoofTrim_StandingSeam.default.json",
  "/static/materials/templates/RoofTrim_StandingSeam.default.json",
  "/static/materials/templates/RoofTrim_StandingSeam.default.json",
  "/static/materials/templates/Shutter.default.json",
  "/static/materials/templates/Soffit_Slat.default.json",
  "/static/materials/templates/Stain_Flat.default.json",
  "/static/materials/templates/Tree_Bark_Generic.default.json",
  "/static/materials/templates/Tree_Foliage_Generic.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/Wood_Generic.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten02x12.default.json",
  "/static/materials/templates/Wall_BoardLap06.default.json",
  "/static/materials/templates/Wall_BoardLap07.default.json",
  "/static/materials/templates/Wall_BoardLap08.default.json",
  "/static/materials/templates/Masonry_Brick_03_Header.default.json",
  "/static/materials/templates/Masonry_Brick_03_Rowlock.default.json",
  "/static/materials/templates/Masonry_Brick_03.default.json",
  "/static/materials/templates/Masonry_Brick_05_Header.default.json",
  "/static/materials/templates/Masonry_Brick_05_Rowlock.default.json",
  "/static/materials/templates/Masonry_Brick_05.default.json",
  "/static/materials/templates/Masonry_Brick_075_Header.default.json",
  "/static/materials/templates/Masonry_Brick_075_Rowlock.default.json",
  "/static/materials/templates/Masonry_Brick_075.default.json",
  "/static/materials/templates/Masonry_Brick_Bracciano_Header.default.json",
  "/static/materials/templates/Masonry_Brick_Bracciano_Rowlock.default.json",
  "/static/materials/templates/Masonry_Brick_Bracciano.default.json",
  "/static/materials/templates/Masonry_BrickKing_Header.default.json",
  "/static/materials/templates/Masonry_BrickKing_Rowlock.default.json",
  "/static/materials/templates/Masonry_BrickKing.default.json",
  "/static/materials/templates/Masonry_BrickQueen_Header.default.json",
  "/static/materials/templates/Masonry_BrickQueen_Rowlock.default.json",
  "/static/materials/templates/Masonry_BrickQueen.default.json",
  "/static/materials/templates/Wall_StaggerBoard05.default.json",
  "/static/materials/templates/Wall_HorizontalBoard04.default.json",
  "/static/materials/templates/Wall_HorizontalBoard05h_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard06.default.json",
  "/static/materials/templates/Masonry_Porcelain_Mandarin_CementoLightGrey.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/Wall_ShakeShingle07.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Monument.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_Breakwater.default.json",
  "/static/materials/templates/Masonry_Stone_Premier_HavannaRubble.default.json",
  "/static/materials/templates/Masonry_Stone_Prostone_Sawgrass.default.json",
  "/static/materials/templates/Masonry_Stone_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone.default.json",
  "/static/materials/templates/Masonry_StoneField_Tan.default.json",
  "/static/materials/templates/Masonry_StoneLimestone_Banks.default.json",
  "/static/materials/templates/Masonry_StoneLimestone_Bridgeport.default.json",
  "/static/materials/templates/Masonry_StoneMixedStack_GrayWarm.default.json",
  "/static/materials/templates/Masonry_StoneRoughCut_Moonlight.default.json",
  "/static/materials/templates/Masonry_StoneThinStack_Gray.default.json",
  "/static/materials/templates/Wall_Stucco.default.json",
  "/static/materials/templates/Wall_StuccoFine.default.json",
  "/static/materials/templates/Wall_VerticalBoard02.default.json",
  "/static/materials/templates/Wall_VerticalBoard04.default.json",
  "/static/materials/templates/Wall_VerticalBoard05.default.json",
  "/static/materials/templates/Wall_VerticalBoard05H.default.json",
  "/static/materials/templates/Wall_VerticalBoard06.default.json",
  "/static/materials/templates/Wall_VerticalBoard08.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/Window.default.json",
  "/static/materials/templates/Wood_HorizontalPlank.default.json",
  "/static/materials/templates/Wood_StaggeredPlank.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/X_PerfTest01.default.json",
  "/static/materials/templates/X_ReflectionTest01.default.json",
  "/static/materials/templates/X_CheckerTest.default.json",
  "/static/materials/templates/Wall_ScaleShingle07.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx16.default.json",
  "/static/materials/templates/Gravel.default.json",
  "/static/materials/templates/Floor_Vinyl_NaturalStone.default.json",
  "/static/materials/templates/OUTDATED_MATERIAL.default.json",
  "/static/materials/templates/Masonry_BrickModular.default.json",
  "/static/materials/templates/Masonry_BrickModular_Header.default.json",
  "/static/materials/templates/Masonry_BrickModular_Rowlock.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Cutstone.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_TerraCut.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_OLD.default.json",
  "/static/materials/templates/Wall_BoardBatten03x08.default.json",
  "/static/materials/templates/Wall_BoardBatten03x48.default.json",
  "/static/materials/templates/Wall_BoardLap07_Grain.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_05_Trim.default.json",
  "/static/materials/templates/Masonry_BrickKing_Herringbone.default.json",
  "/static/materials/templates/Masonry_BrickModular_Herringbone.default.json",
  "/static/materials/templates/Masonry_BrickQueen_Herringbone.default.json",
  "/static/materials/templates/Wall_Tile06x12_Carrara.default.json",
  "/static/materials/templates/Wall_Tile.default.json",
  "/static/materials/templates/Wall_ShakeShingleStraight07.default.json",
  "/static/materials/templates/Roof_AsphaltBelmont.default.json",
  "/static/materials/templates/Roof_AsphaltCarriageHouse.default.json",
  "/static/materials/templates/CT_Landmark_Pro.default.json",
  "/static/materials/templates/Roof_AsphaltGrandManor.default.json",
  "/static/materials/templates/Roof_AsphaltHighlandSlate.default.json",
  "/static/materials/templates/Wall_BoardLap04.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_SolidTrim.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge.default.json",
  "/static/materials/templates/Wall_BoardBatten02x16_Grain.default.json",
  "/static/materials/templates/Wall_BoardBatten02x16.default.json",
  "/static/materials/templates/Masonry_BrickKing_HalfHeight.default.json",
  "/static/materials/templates/Masonry_BrickQueen_HalfHeight.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_Sawn.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_OLD.default.json",
  "/static/materials/templates/Lattice_45deg_1x1.default.json",
  "/static/materials/templates/Masonry_BrickKing_ThinCut.default.json",
  "/static/materials/templates/Masonry_BrickQueen_ThinCut.default.json",
  "/static/materials/templates/Masonry_BrickEstate.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_24_Trim.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx12.default.json",
  "/static/materials/templates/Wall_ShakeShingle06.default.json",
  "/static/materials/templates/Roof_WoodShake_10x10.default.json",
  "/static/materials/templates/Roof_AsphaltShakeStraight.default.json",
  "/static/materials/templates/RoofTile_Capistrano.default.json",
  "/static/materials/templates/Wall_BoardLapAlternating04x07.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx12.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx16.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten01x08.default.json",
  "/static/materials/templates/Wall_BoardBatten01x12.default.json",
  "/static/materials/templates/Wall_BoardBatten01x16.default.json",
  "/static/materials/templates/Wall_BoardBatten01x24.default.json",
  "/static/materials/templates/Wall_BoardBatten01x48.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten02x08.default.json",
  "/static/materials/templates/Wall_BoardBatten02x24.default.json",
  "/static/materials/templates/Wall_BoardBatten02x48.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx12.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx16.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten03x12.default.json",
  "/static/materials/templates/Wall_BoardBatten03x16.default.json",
  "/static/materials/templates/Wall_BoardBatten03x24.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx12.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx16.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten04x08.default.json",
  "/static/materials/templates/Wall_BoardBatten04x12.default.json",
  "/static/materials/templates/Wall_BoardBatten04x16.default.json",
  "/static/materials/templates/Wall_BoardBatten04x24.default.json",
  "/static/materials/templates/Wall_BoardBatten04x48.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx12.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx16.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten05x08.default.json",
  "/static/materials/templates/Wall_BoardBatten05x12.default.json",
  "/static/materials/templates/Wall_BoardBatten05x16.default.json",
  "/static/materials/templates/Wall_BoardBatten05x24.default.json",
  "/static/materials/templates/Wall_BoardBatten05x48.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx08.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx12.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx16.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx24.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx48.default.json",
  "/static/materials/templates/Wall_BoardBatten06x08.default.json",
  "/static/materials/templates/Wall_BoardBatten06x12.default.json",
  "/static/materials/templates/Wall_BoardBatten06x16.default.json",
  "/static/materials/templates/Wall_BoardBatten06x24.default.json",
  "/static/materials/templates/Wall_BoardBatten06x48.default.json",
  "/static/materials/templates/Masonry_Stone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_24_Trim.default.json",
  "/static/materials/templates/Prop_BlackGlass.default.json",
  "/static/materials/templates/Wall_StuccoScored04.default.json",
  "/static/materials/templates/Wall_StuccoScored06.default.json",
  "/static/materials/templates/Wall_StuccoScored07.default.json",
  "/static/materials/templates/Wall_StuccoScored08.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten01x20.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten02x20.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten03x20.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten04x20.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten05x20.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx20.default.json",
  "/static/materials/templates/Wall_BoardBatten06x20.default.json",
  "/static/materials/templates/Wall_BoardLap04_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap06_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap08_Grain.default.json",
  "/static/materials/templates/Wall_ReverseBatten05hx01.default.json",
  "/static/materials/templates/Wall_BoardLapAlternating05x08.default.json",
  "/static/materials/templates/Roof_StandingSeam18.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamChisel.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamChisel_Trim.default.json",
  "/static/materials/templates/Wall_BoardLap05_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap05.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamTivoli_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamTivoli.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_GrezzoRosa_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_GrezzoRosa.default.json",
  "/static/materials/templates/Masonry_Stone_MountainLedge_GreyDrift_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_MountainLedge_GreyDrift.default.json",
  "/static/materials/templates/Masonry_Stone_ProstackLite_IronSmoke_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_ProstackLite_IronSmoke.default.json",
  "/static/materials/templates/Masonry_Stone_Sabbie_NereGrezzo_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Sabbie_NereGrezzo.default.json",
  "/static/materials/templates/Wall_HorizontalBoard04_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard05_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard05.default.json",
  "/static/materials/templates/Wall_HorizontalBoard05h_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard06_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard07_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard07.default.json",
  "/static/materials/templates/Wall_HorizontalBoard08_Grain.default.json",
  "/static/materials/templates/Wall_HorizontalBoard08.default.json",
  "/static/materials/templates/Wood_Sheathing96x48.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_SouthernLedgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Cliffstone_OLD.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Roughcut.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_AlpineLedgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_DrystackLedgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_EuropeanLedge.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_RusticLedge.default.json",
  "/static/materials/templates/Masonry_Stone_General_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_General_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_General_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_General_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_RidgeCut.default.json",
  "/static/materials/templates/Roof_WoodShake_10xVariable.default.json",
  "/static/materials/templates/Wall_HorizontalBoard02_01hx48vertical.default.json",
  "/static/materials/templates/Paver_Tpattern_6x6_6x9.default.json",
  "/static/materials/templates/Wall_BoardLap02_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap02.default.json",
  "/static/materials/templates/Masonry_Stone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_CountryLedgestone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_MountainLedge_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamChisel_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_CreamTivoli_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_Cutstone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Environmental_GrezzoRosa_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_MountainLedge_GreyDrift_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_ProstackLite_IronSmoke_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_RockMaterials_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Sabbie_NereGrezzo_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_TerraCut_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Vener_Cobblestone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_03_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_03_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_05_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_05_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_12_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_12_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_24_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_24_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone_OLD.default.json",
  "/static/materials/templates/Wall_BoardLap04h_Dutch.default.json",
  "/static/materials/templates/Masonry_BrickExecutive_HalfHeight.default.json",
  "/static/materials/templates/Masonry_BrickExecutive_Header.default.json",
  "/static/materials/templates/Masonry_BrickExecutive_Herringbone.default.json",
  "/static/materials/templates/Masonry_BrickExecutive_Rowlock.default.json",
  "/static/materials/templates/Masonry_BrickExecutive_ThinCut.default.json",
  "/static/materials/templates/Masonry_BrickExecutive.default.json",
  "/static/materials/templates/SolarPanel_6x6.default.json",
  "/static/materials/templates/Stone_BlancoBuilders.default.json",
  "/static/materials/templates/Stone_RattlesnakeBuilders.default.json",
  "/static/materials/templates/Stone_SunflowerChop.default.json",
  "/static/materials/templates/Stone_TexasMix.default.json",
  "/static/materials/templates/Stone_TumbleweedTan.default.json",
  "/static/materials/templates/Masonry_Stone_RoughAshlar.default.json",
  "/static/materials/templates/Masonry_Stone_RM_Chopped.default.json",
  "/static/materials/templates/RoofTile_Elabana.default.json",
  "/static/materials/templates/Wall_StuccoScored10.default.json",
  "/static/materials/templates/Wall_StuccoScored12.default.json",
  "/static/materials/templates/Wall_StuccoScored14.default.json",
  "/static/materials/templates/Wall_StuccoScored16.default.json",
  "/static/materials/templates/Wall_StuccoScored18.default.json",
  "/static/materials/templates/Wall_StuccoScored20.default.json",
  "/static/materials/templates/Wall_StuccoScored22.default.json",
  "/static/materials/templates/Wall_StuccoScored24.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_NaturalCut.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_PrecisionFit.default.json",
  "/static/materials/templates/Masonry_BrickModular_Weave3.default.json",
  "/static/materials/templates/Masonry_BrickModular_HalfHeight.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx06q.default.json",
  "/static/materials/templates/Masonry_Stone_Drystack.default.json",
  "/static/materials/templates/Masonry_Stone_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_Fieldstone.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten01x07.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten02x07.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten03x07.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten04x07.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten05x07.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx07.default.json",
  "/static/materials/templates/Wall_BoardBatten06x07.default.json",
  "/static/materials/templates/Wall_BoardLap12_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap12.default.json",
  "/static/materials/templates/Wall_ShakeShingleStraight05.default.json",
  "/static/materials/templates/Wall_ShakeShingleStraight06.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx09.default.json",
  "/static/materials/templates/Masonry_Stone_StackLedge.default.json",
  "/static/materials/templates/Patio_Stone_01.default.json",
  "/static/materials/templates/Roof_MetalShakeStraight12.default.json",
  "/static/materials/templates/Masonry_Stone_MV_HackettStone.default.json",
  "/static/materials/templates/Masonry_Stone_MV_StackStone.default.json",
  "/static/materials/templates/Masonry_Stone_CDS_Blend.default.json",
  "/static/materials/templates/Masonry_Stone_CDS_CountryRubble.default.json",
  "/static/materials/templates/Masonry_Stone_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_CDS_Volterra.default.json",
  "/static/materials/templates/Masonry_Stone_PV_WesternLedge.default.json",
  "/static/materials/templates/Masonry_Stone_General_16_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_16_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_RM_Bluebonnet.default.json",
  "/static/materials/templates/Masonry_Stone_RM_Sawn.default.json",
  "/static/materials/templates/Masonry_Stone_RM_ChoppedLimestone.default.json",
  "/static/materials/templates/Wall_ShakeShingle09.default.json",
  "/static/materials/templates/Wall_HorizontalBoard08_Angle45L.default.json",
  "/static/materials/templates/Wall_HorizontalBoard08_Angle45R.default.json",
  "/static/materials/templates/Asphalt_Default.default.json",
  "/static/materials/templates/Metal_Galvanized_01.default.json",
  "/static/materials/templates/Masonry_Stone_General_Trim.default.json",
  "/static/materials/templates/Roof_StandingSeam15.default.json",
  "/static/materials/templates/Masonry_Stone_General_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_PS_OldCountyLedge.default.json",
  "/static/materials/templates/Masonry_Stone_PS_SouthernLimestone.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge.default.json",
  "/static/materials/templates/Wall_BoardBatten01hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten01x36.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten02x36.default.json",
  "/static/materials/templates/Wall_BoardBatten03hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten03x36.default.json",
  "/static/materials/templates/Wall_BoardBatten04hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten04x36.default.json",
  "/static/materials/templates/Wall_BoardBatten05hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten05x36.default.json",
  "/static/materials/templates/Wall_BoardBatten06hx36.default.json",
  "/static/materials/templates/Wall_BoardBatten06x36.default.json",
  "/static/materials/templates/Wall_VerticalBoard02_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard04_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard05_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard05H_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard06_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard08_Grain.default.json",
  "/static/materials/templates/Masonry_Stone_General_20_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_20_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Ridgetop.default.json",
  "/static/materials/templates/RoofTile_Slate.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_08_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_Weatherledge_08_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_PlyGem_CanyonLedge.default.json",
  "/static/materials/templates/Masonry_Stone_Eco_CountryRidge.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_FieldLedge.default.json",
  "/static/materials/templates/Masonry_Stone_Eco_Ridgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_TundraBrick.default.json",
  "/static/materials/templates/Masonry_BrickDoubleMonarch_StackBond.default.json",
  "/static/materials/templates/Roof_StandingSeam24.default.json",
  "/static/materials/templates/Masonry_Stone_PlyGem_Manorstone.default.json",
  "/static/materials/templates/Roof_StandingSeam14.default.json",
  "/static/materials/templates/Wall_BoardLap06_Gap01h.default.json",
  "/static/materials/templates/Wall_VerticalBoard06_Beaded01h.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_RoughAshlar.default.json",
  "/static/materials/templates/Masonry_Stone_MES_SoutheasternLedge.default.json",
  "/static/materials/templates/Masonry_Stone_MES_StackedStone.default.json",
  "/static/materials/templates/Masonry_Stone_MES_Weatheredledge.default.json",
  "/static/materials/templates/Masonry_Stone_BC_StoneVeneerSangria.default.json",
  "/static/materials/templates/Masonry_BrickEngineer.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_StackedStone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Cliffstone.default.json",
  "/static/materials/templates/Masonry_CinderBlock08x16.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Divino.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Drystone.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Leuders.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Uintah.default.json",
  "/static/materials/templates/Masonry_Stone_Stonecraft_Ledgestone.default.json",
  "/static/materials/templates/Wall_Board48x120_Battens02h.default.json",
  "/static/materials/templates/Masonry_Stone_MES_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_StackedStone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Cliffstone.default.json",
  "/static/materials/templates/Floor_Vinyl.default.json",
  "/static/materials/templates/Masonry_Stone_Horizon_19thCenturyStone.default.json",
  "/static/materials/templates/Wall_BoardLap10_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap10.default.json",
  "/static/materials/templates/Wall_BoardBatten02hx16_Grain.default.json",
  "/static/materials/templates/Masonry_Stone_Centurion_Elkmont.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_Drystack.default.json",
  "/static/materials/templates/Wood_Generic_V.default.json",
  "/static/materials/templates/Metal_Screen_Black.default.json",
  "/static/materials/templates/Floor_ConcreteBroomFinish.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_QR_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_QR_CountryLedgestone.default.json",
  "/static/materials/templates/Masonry_Stone_QR_WeatheredEdge.default.json",
  "/static/materials/templates/Metal_Grate.default.json",
  "/static/materials/templates/Masonry_Stone_QR_RusticLedgestone.default.json",
  "/static/materials/templates/Tile_17x17.default.json",
  "/static/materials/templates/Wall_BoardLap04h.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_Hackett.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_LimeStackMix.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_RomanCastle.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_StackStone.default.json",
  "/static/materials/templates/Masonry_Stone_General_48_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_48_Trim.default.json",
  "/static/materials/templates/Tile_12x12.default.json",
  "/static/materials/templates/TileBath_4x12.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_Edgecut.default.json",
  "/static/materials/templates/Masonry_Stone_General_08_Trim_V.default.json",
  "/static/materials/templates/Masonry_Stone_General_08_Trim.default.json",
  "/static/materials/templates/Masonry_Stone_BC_MontanaLedge.default.json",
  "/static/materials/templates/Masonry_Stone_BC_OhioRubble.default.json",
  "/static/materials/templates/Masonry_Stone_BC_PrairieBluff.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_CoarseCutStone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_CypressRidge.default.json",
  "/static/materials/templates/Masonry_Stone_BC_CountryLedge.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_PlyGem_ShadowLedgestone.default.json",
  "/static/materials/templates/X_FrostedGlass.default.json",
  "/static/materials/templates/Masonry_Stone_Centurion_Stack.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_StackLedge.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_DQ_Weatherledge.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_SierraCut.default.json",
  "/static/materials/templates/Masonry_Stone_FDL_Biltmore.default.json",
  "/static/materials/templates/Masonry_Stone_FDL_Country.default.json",
  "/static/materials/templates/Masonry_Stone_Bello_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_Bello_Fieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_Bello_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_BrandCo_Drystack.default.json",
  "/static/materials/templates/Masonry_Stone_BrandCo_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_CDS_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_CH_ChiseledEdge.default.json",
  "/static/materials/templates/Masonry_Stone_Cobra_TexasLimestone.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_MV_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_MV_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_PlyGem_Fieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_PlyGem_CascadeLedge.default.json",
  "/static/materials/templates/Masonry_Stone_PS_Weatherledge.default.json",
  "/static/materials/templates/Masonry_Stone_Prostone_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_PV_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_QR_DressedFieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Chisel.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Fieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Grezzo.default.json",
  "/static/materials/templates/Masonry_Stone_Env_ProstackLite.default.json",
  "/static/materials/templates/Masonry_Stone_Env_Tivoli.default.json",
  "/static/materials/templates/Masonry_Stone_IS_Fieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_QS_Fieldstone.default.json",
  "/static/materials/templates/Masonry_Stone_Premier_Stack.default.json",
  "/static/materials/templates/Wall_PanelBoard_48x24.default.json",
  "/static/materials/templates/Wall_PanelBoard_V_48.default.json",
  "/static/materials/templates/Masonry_Stone_Centurion_Hackett.default.json",
  "/static/materials/templates/Masonry_Stone_Centurion_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_Centurion_Rubble.default.json",
  "/static/materials/templates/Masonry_Stone_Cultured_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_DP_Vener_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_Eldorado_Bluffstone.default.json",
  "/static/materials/templates/Masonry_Stone_Halquist_Ledge.default.json",
  "/static/materials/templates/Masonry_Stone_Harristone_Tumbled.default.json",
  "/static/materials/templates/Masonry_Stone_Lurveys_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_Metrobrick_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_MGBS_AustinLimestone.default.json",
  "/static/materials/templates/Masonry_Stone_MGBS_LeudersLimestone.default.json",
  "/static/materials/templates/Masonry_Stone_MGBS_LimestoneBlends.default.json",
  "/static/materials/templates/Masonry_Stone_Pioneer_StackEase.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_ChiselCut.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_DryStack.default.json",
  "/static/materials/templates/Masonry_Stone_ProVia_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_QS_Cobblestone.default.json",
  "/static/materials/templates/Masonry_Stone_QS_Drystack.default.json",
  "/static/materials/templates/Masonry_Stone_RM_SawnBuilding.default.json",
  "/static/materials/templates/Masonry_Stone_RM_Waterford.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_3_5Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_CastleStone.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_EuropeanCastle.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_EuropeanCobble.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_KCBlend.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_Ledgestone.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_Limestone.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_MidwestQuickfit.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_MountainRubble.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_Quickfit.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_SawtoothLedge.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_SouthernLedge.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_StackHackett.default.json",
  "/static/materials/templates/Masonry_Stone_SCM_ThinkBrick.default.json",
  "/static/materials/templates/Masonry_Stone_Versetta_Ledgestone.default.json",
  "/static/materials/templates/Wall_BoardLap03_Grain.default.json",
  "/static/materials/templates/Wall_BoardLap03.default.json",
  "/static/materials/templates/Wall_VerticalBoard03_Grain.default.json",
  "/static/materials/templates/Wall_VerticalBoard03.default.json",
];
